<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .background-tab {
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
    overflow: auto;
    padding-top: utils.in_rem(16px);

    .share-header {
      align-items: center;
      background: colors.get(interfaceSwGrey_4);
      border-radius: utils.in_rem(8px);
      display: flex;
      justify-content: space-between;
      padding: 0 utils.in_rem(4px) 0 utils.in_rem(12px);

      .resume-type {
        @include mixins.body2();
        @include colors.color(textDisabledGrey);
      }
    }

    .sections-container {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(24px);
      overflow: auto;
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import EducationSection from "../../../../components/BackgroundModal/EducationSection.svelte";
  import ExperienceSection from "../../../../components/BackgroundModal/ExperienceSection.svelte";
  import {
    activePopUpModalStore,
    candidateEducationStore,
    candidateExperienceStore,
  } from "../../stores";
  import BackgroundSkeleton from "./BackgroundSkeleton.svelte";

  const { meta: experienceMeta } = candidateExperienceStore;
  const { meta: educationMeta } = candidateEducationStore;

  let isLoading = $derived(
    ($experienceMeta.fetching && !$experienceMeta.firstFetchDone) ||
      ($educationMeta.fetching && !$educationMeta.firstFetchDone)
  );

  // Transform store data: convert date strings to Unix timestamps
  // The stores return date strings (ISO format), but ModalBody expects Unix timestamps
  let experience = $derived.by(() =>
    $candidateExperienceStore.map((exp) => ({
      ...exp,
      startedAt: exp.startedAt
        ? Math.floor(new Date(exp.startedAt).getTime() / 1000)
        : null,
      endedAt: exp.endedAt
        ? Math.floor(new Date(exp.endedAt).getTime() / 1000)
        : null,
    }))
  );

  let education = $derived.by(() =>
    $candidateEducationStore.map((edu) => ({
      ...edu,
      startedAt: edu.startedAt
        ? Math.floor(new Date(edu.startedAt).getTime() / 1000)
        : null,
      endedAt: edu.endedAt
        ? Math.floor(new Date(edu.endedAt).getTime() / 1000)
        : null,
    }))
  );

  const openShareResumeModal = () => {
    activePopUpModalStore.set({
      modal: "shareResume",
    });
  };
</script>

<div class="background-tab">
  <div class="share-header">
    <span class="resume-type">Linkedin Resume</span>
    <Button
      kind="ghost-blue"
      size="small"
      trailingIcon="fa-arrow-right"
      onclick={openShareResumeModal}>Share resume</Button
    >
  </div>

  {#if isLoading}
    <BackgroundSkeleton />
  {:else}
    <div class="sections-container">
      <ExperienceSection {experience} />
      <EducationSection {education} />
    </div>
  {/if}
</div>
